/* eslint-disable react/prop-types */
// Generators for downloadable scripts used by the "Tecnico" admin tab.
// VPS Contabo deja configurat cu HestiaCP — scripturile NU ating Nginx/Apache/UFW/MongoDB/certbot.
// Backend FastAPI rulează pe portul 8004 (8001-8003 sunt ocupate).
// User HestiaCP: baronefunebre — domeniu: baronefunebre.it.

export const INSTALL_SH = `#!/usr/bin/env bash
# =============================================================================
# Agenzia Funebre Barone — Installazione su VPS Contabo + HestiaCP
# Dominio: baronefunebre.it (utente HestiaCP: baronefunebre)
# Backend FastAPI port: 8004 (8001-8003 sono già occupati)
# =============================================================================
# SICUREZZA: questo script NON tocca Nginx/Apache/UFW/MongoDB/certbot.
# Hestia gestisce già: web server, SSL Let's Encrypt, firewall, MariaDB, email.
# Eseguire come ROOT su SSH (porta 1992).
# =============================================================================
set -euo pipefail

DOMAIN="\${DOMAIN:-baronefunebre.it}"
HUSER="\${HUSER:-baronefunebre}"
BACKEND_PORT="\${BACKEND_PORT:-8004}"
GITHUB_REPO="\${GITHUB_REPO:-https://github.com/<utente>/baronefunebre.git}"

HHOME="/home/\$HUSER"
APP_DIR="\$HHOME/barone-app"                            # codice (privato)
PUBLIC_HTML="\$HHOME/web/\$DOMAIN/public_html"          # frontend build → servito da Hestia
HESTIA_DOMAIN_CONF="\$HHOME/conf/web/\$DOMAIN"

MONGO_DBNAME="barone"
ADMIN_USERNAME="admin"
ADMIN_PASSWORD="\${ADMIN_PASSWORD:-GiuseppeBarone}"
JWT_SECRET="\${JWT_SECRET:-\$(openssl rand -hex 32)}"
RESEND_API_KEY="\${RESEND_API_KEY:-}"

echo ">>> 0. Verifica prerequisiti"
[ "\$(id -u)" -eq 0 ] || { echo "Esegui come root"; exit 1; }
[ -d "\$HHOME" ] || { echo "Utente HestiaCP '\$HUSER' inesistente. Crealo da Hestia panel prima."; exit 1; }
[ -d "\$PUBLIC_HTML" ] || { echo "Domain '\$DOMAIN' non configurato in Hestia. Aggiungilo dal panel."; exit 1; }
command -v mongod >/dev/null || { echo "MongoDB non trovato"; exit 1; }
command -v python3 >/dev/null || { echo "Python3 non trovato"; exit 1; }
ss -tulpn | grep -q ":\$BACKEND_PORT " && { echo "Porta \$BACKEND_PORT già in uso!"; exit 1; }

echo ">>> 1. Node 20 + Yarn (solo se mancano)"
if ! command -v node >/dev/null || ! node -v | grep -qE "^v(20|22)"; then
  curl -fsSL https://deb.nodesource.com/setup_20.x | bash -
  apt-get install -y nodejs
fi
command -v yarn >/dev/null || npm install -g yarn
command -v rsync >/dev/null || apt-get install -y rsync
command -v git >/dev/null || apt-get install -y git

echo ">>> 2. Clone repo in \$APP_DIR"
mkdir -p "\$APP_DIR"
chown -R "\$HUSER:\$HUSER" "\$APP_DIR"
sudo -u "\$HUSER" -H bash -lc "
  cd '\$APP_DIR'
  if [ ! -d .git ]; then
    git clone '\$GITHUB_REPO' .
  fi
"

echo ">>> 3. Backend — venv + dipendenze"
sudo -u "\$HUSER" -H bash -lc "
  cd '\$APP_DIR/backend'
  python3 -m venv venv
  . venv/bin/activate
  pip install --upgrade pip
  pip install -r requirements.txt
  deactivate
"

cat > "\$APP_DIR/backend/.env" <<EOF
MONGO_URL=mongodb://127.0.0.1:27017
DB_NAME=\$MONGO_DBNAME
CORS_ORIGINS=https://\$DOMAIN,https://www.\$DOMAIN
JWT_SECRET=\$JWT_SECRET
ADMIN_USERNAME=\$ADMIN_USERNAME
ADMIN_PASSWORD=\$ADMIN_PASSWORD
RESEND_API_KEY=\$RESEND_API_KEY
SENDER_EMAIL=noreply@\$DOMAIN
APP_ROOT=\$APP_DIR
BARONE_BACKUP_ROOT=\$HHOME/barone-backups
SUPERVISOR_RESTART_CMD=systemctl restart barone-backend
EOF
chown "\$HUSER:\$HUSER" "\$APP_DIR/backend/.env"
chmod 600 "\$APP_DIR/backend/.env"

echo ">>> 4. Frontend — build e deploy in public_html"
sudo -u "\$HUSER" -H bash -lc "
  cd '\$APP_DIR/frontend'
  cat > .env <<EOF2
REACT_APP_BACKEND_URL=https://\$DOMAIN
WDS_SOCKET_PORT=0
EOF2
  yarn install --frozen-lockfile
  yarn build
  rsync -a --delete build/ '\$PUBLIC_HTML/'
"

echo ">>> 5. systemd service barone-backend (porta \$BACKEND_PORT)"
cat > /etc/systemd/system/barone-backend.service <<EOF
[Unit]
Description=Agenzia Funebre Barone — FastAPI backend
After=network.target mongod.service

[Service]
Type=simple
User=\$HUSER
Group=\$HUSER
WorkingDirectory=\$APP_DIR/backend
Environment=PATH=\$APP_DIR/backend/venv/bin
EnvironmentFile=\$APP_DIR/backend/.env
ExecStart=\$APP_DIR/backend/venv/bin/uvicorn server:app --host 127.0.0.1 --port \$BACKEND_PORT
Restart=always
RestartSec=3

[Install]
WantedBy=multi-user.target
EOF
systemctl daemon-reload
systemctl enable --now barone-backend
sleep 3
systemctl --no-pager status barone-backend | head -10

echo ">>> 6. Sudoers — permetti all'utente \$HUSER di restart/aggiornamento OTA"
cat > /etc/sudoers.d/barone-backend <<EOF
\$HUSER ALL=(root) NOPASSWD: /bin/systemctl restart barone-backend, /bin/systemctl status barone-backend, /usr/bin/systemctl restart barone-backend, /usr/bin/systemctl status barone-backend
EOF
chmod 440 /etc/sudoers.d/barone-backend

echo ">>> 7. Snippet Nginx da aggiungere via Hestia (NON sovrascrive nulla)"
SNIPPET_DIR="\$HESTIA_DOMAIN_CONF"
SNIPPET_FILE="\$SNIPPET_DIR/nginx.api_8004.conf_custom"
mkdir -p "\$SNIPPET_DIR"
cat > "\$SNIPPET_FILE" <<EOF
# Inclusione manuale: proxy /api → FastAPI sulla porta \$BACKEND_PORT
location /api/ {
    proxy_pass http://127.0.0.1:\$BACKEND_PORT;
    proxy_set_header Host \\\$host;
    proxy_set_header X-Real-IP \\\$remote_addr;
    proxy_set_header X-Forwarded-For \\\$proxy_add_x_forwarded_for;
    proxy_set_header X-Forwarded-Proto \\\$scheme;
    proxy_read_timeout 120s;
    proxy_send_timeout 120s;
    client_max_body_size 200m;
}

location / {
    try_files \\\$uri /index.html;
}
EOF
chown "\$HUSER:\$HUSER" "\$SNIPPET_FILE"

echo ""
echo "============================================================"
echo "✅ INSTALLAZIONE BACKEND/FRONTEND COMPLETATA"
echo "============================================================"
echo "Backend:      systemctl status barone-backend  (porta \$BACKEND_PORT)"
echo "API test:     curl http://127.0.0.1:\$BACKEND_PORT/api/content"
echo "Build:        \$PUBLIC_HTML"
echo "Codice:       \$APP_DIR"
echo "Snippet:      \$SNIPPET_FILE"
echo ""
echo "⚠️  AZIONE MANUALE — collega il proxy /api in Hestia:"
echo "    1. Login Hestia (https://<ip>:8083) come admin"
echo "    2. WEB → \$DOMAIN → Edit → Advanced Options"
echo "    3. Nginx Template: imposta 'default' (o 'proxy_default')"
echo "    4. Proxy Extensions: lascia vuoto (la SPA gestisce le rotte)"
echo "    5. Aggiungi 'Web Domain Aliases' se serve: www.\$DOMAIN"
echo "    6. Save → Hestia rigenera /home/\$HUSER/conf/web/\$DOMAIN/nginx*.conf"
echo "    7. Modifica manualmente quel file aggiungendo all'inizio del"
echo "       blocco 'server { listen 443 ssl;' la riga:"
echo "          include \$SNIPPET_FILE;"
echo "       (oppure usa un template Nginx personalizzato)"
echo "    8. systemctl reload nginx"
echo ""
echo "Login admin:  https://\$DOMAIN/admin  →  \$ADMIN_USERNAME / \$ADMIN_PASSWORD"
echo "============================================================"
`;

export const UPGRADE_SH = `#!/usr/bin/env bash
# =============================================================================
# Agenzia Funebre Barone — Upgrade lato VPS (HestiaCP)
# Esegue git pull, ricostruisce frontend, riavvia backend.
# Se la health-check fallisce, ripristina la versione precedente.
# =============================================================================
# NOTA: l'upgrade OTA dal panel admin del sito fa la stessa cosa via API.
# Questo script è il fallback CLI in caso di problemi.
# =============================================================================
set -euo pipefail

DOMAIN="\${DOMAIN:-baronefunebre.it}"
HUSER="\${HUSER:-baronefunebre}"
HHOME="/home/\$HUSER"
APP_DIR="\${APP_DIR:-\$HHOME/barone-app}"
PUBLIC_HTML="\$HHOME/web/\$DOMAIN/public_html"
BACKEND_PORT="\${BACKEND_PORT:-8004}"
BACKUP_ROOT="\${BACKUP_ROOT:-\$HHOME/barone-backups}"
TS="\$(date +%Y%m%d-%H%M%S)"
BACKUP_DIR="\$BACKUP_ROOT/snapshot-\$TS"

mkdir -p "\$BACKUP_ROOT"

echo ">>> 1. Snapshot versione attuale → \$BACKUP_DIR"
mkdir -p "\$BACKUP_DIR"
rsync -a --exclude node_modules --exclude build --exclude .venv --exclude venv --exclude __pycache__ \\
  "\$APP_DIR/" "\$BACKUP_DIR/code/"
rsync -a "\$PUBLIC_HTML/" "\$BACKUP_DIR/public_html/"

cd "\$APP_DIR"
PREV_COMMIT="\$(git rev-parse HEAD)"
echo ">>> 2. git pull (commit attuale: \$PREV_COMMIT)"
sudo -u "\$HUSER" -H git fetch origin
sudo -u "\$HUSER" -H git pull --ff-only

echo ">>> 3. Backend dipendenze"
sudo -u "\$HUSER" -H bash -lc "
  cd '\$APP_DIR/backend'
  . venv/bin/activate
  pip install -r requirements.txt
  deactivate
"

echo ">>> 4. Frontend build + deploy in public_html"
sudo -u "\$HUSER" -H bash -lc "
  cd '\$APP_DIR/frontend'
  yarn install --frozen-lockfile
  yarn build
  rsync -a --delete build/ '\$PUBLIC_HTML/'
"

echo ">>> 5. Restart backend"
systemctl restart barone-backend
sleep 5

echo ">>> 6. Health check"
CODE=\$(curl -s -o /dev/null -w "%{http_code}" --max-time 5 "http://127.0.0.1:\$BACKEND_PORT/api/content" || echo 000)
TRIES=0
while [ "\$CODE" != "200" ] && [ \$TRIES -lt 4 ]; do
  sleep 3
  CODE=\$(curl -s -o /dev/null -w "%{http_code}" --max-time 5 "http://127.0.0.1:\$BACKEND_PORT/api/content" || echo 000)
  TRIES=\$((TRIES+1))
done

if [ "\$CODE" != "200" ]; then
  echo "❌ Health check fallito (HTTP \$CODE). Rollback in corso..."

  # ripristina codice (preservando node_modules / .venv / .git esistenti)
  rsync -a --delete \\
    --filter='P node_modules' --filter='P .venv' --filter='P venv' \\
    --filter='P .git' --filter='P frontend/node_modules' --filter='P frontend/build' \\
    "\$BACKUP_DIR/code/" "\$APP_DIR/"
  rsync -a --delete "\$BACKUP_DIR/public_html/" "\$PUBLIC_HTML/"

  systemctl restart barone-backend
  sleep 5
  CODE2=\$(curl -s -o /dev/null -w "%{http_code}" --max-time 5 "http://127.0.0.1:\$BACKEND_PORT/api/content" || echo 000)
  echo "Rollback completato. Status: HTTP \$CODE2"
  exit 1
fi

# Pulisci snapshot oltre i 10 più recenti
ls -1dt "\$BACKUP_ROOT"/snapshot-* 2>/dev/null | tail -n +11 | xargs -r rm -rf

echo "============================================================"
echo "✅ Upgrade completato!"
echo "   \$PREV_COMMIT → \$(git -C "\$APP_DIR" rev-parse HEAD)"
echo "   Snapshot:  \$BACKUP_DIR"
echo "============================================================"
`;

export const GITHUB_PUSH_MD = `# Push backup su GitHub

Suggerimento: usa un repo **PRIVATO** (contiene i tuoi dati e .env).

## Setup iniziale (sul PC o sul VPS come utente \`baronefunebre\`)

\`\`\`bash
cd /home/baronefunebre/barone-app
git init
git remote add origin https://github.com/<tuo-utente>/baronefunebre.git
\`\`\`

Crea un file \`.gitignore\` (se manca):

\`\`\`gitignore
backend/.env
frontend/.env
backend/venv/
frontend/node_modules/
frontend/build/
barone-backups/
__pycache__/
*.pyc
.DS_Store
\`\`\`

## Push manuale

\`\`\`bash
git add .
git commit -m "Backup $(date +%Y-%m-%d)"
git branch -M main
git push -u origin main
\`\`\`

## Backup automatico giornaliero (cron sul VPS)

Come utente \`baronefunebre\`:

\`\`\`bash
crontab -e
\`\`\`

Aggiungi:

\`\`\`cron
# Auto-backup ogni notte alle 03:00
0 3 * * * cd /home/baronefunebre/barone-app && git add -A && git commit -m "Auto-backup $(date +\\%F)" >/dev/null 2>&1 && git push origin main >/dev/null 2>&1
\`\`\`

## Dump database MongoDB

Backup separato per il database (esegui come utente \`baronefunebre\`):

\`\`\`bash
# Dump nightly
mkdir -p /home/baronefunebre/barone-backups/mongo
mongodump --uri="mongodb://127.0.0.1:27017" --db=barone \\
  --archive="/home/baronefunebre/barone-backups/mongo/barone-$(date +%Y%m%d).gz" --gzip

# Restore (se serve)
mongorestore --uri="mongodb://127.0.0.1:27017" --gzip \\
  --archive="/home/baronefunebre/barone-backups/mongo/barone-YYYYMMDD.gz"
\`\`\`

Cron giornaliero (utente \`baronefunebre\`):

\`\`\`cron
30 3 * * * mongodump --uri="mongodb://127.0.0.1:27017" --db=barone --archive="/home/baronefunebre/barone-backups/mongo/barone-$(date +\\%Y\\%m\\%d).gz" --gzip >/dev/null 2>&1
\`\`\`
`;
